import {createContext} from 'react'
import {getDefaultStatefulContext, State} from "@lib/hooks/types";

export const SideNavContext = createContext<State<boolean>>(getDefaultStatefulContext<boolean>(false))
